import React, { FC, useState } from 'react';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';

import { useCreateUpdateLeaderboardConfigMutation, LeaderboardConfigInput } from 'api';
import { useNotify } from 'hooks';
import { LeaderboardSchema } from 'features/admin/validations';
import { useCreateLeaderboard } from 'features/admin/updaters';

import Title from './Title';

const EMPTY_LEADERBOARD: LeaderboardConfigInput = {
  title: '',
};

const LeaderboardCreate: FC = () => {
  const [working, setWorking] = useState(false);
  const notify = useNotify();

  const mutationOptions = useCreateLeaderboard();
  const { mutateAsync } = useCreateUpdateLeaderboardConfigMutation(mutationOptions);

  function createNotify() {
    notify.info({ i18n: { i18nKey: 'common:saved' } });
    setWorking(false);
  }

  async function handleCreate(
    values: LeaderboardConfigInput,
    helpers: FormikHelpers<LeaderboardConfigInput>
  ) {
    try {
      await mutateAsync({ data: values });
      helpers.resetForm();
      createNotify();
    } catch (e) {
      notify.mutationError();
    }

    setWorking(false);
  }

  return (
    <Formik
      initialValues={EMPTY_LEADERBOARD}
      onSubmit={handleCreate}
      validationSchema={LeaderboardSchema(false)}
      render={() => (
        <FormikForm>
          <Title working={working} i18nKey="common:add" />
        </FormikForm>
      )}
    />
  );
};

export default LeaderboardCreate;
